import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { DatePipe } from '@angular/common';
import { Globals } from "../../globals";
import { OrdersCoServices } from '../orders/services';
import { IncomeExpensesServices } from '../income-expenses/services';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LoadingController } from 'ionic-angular';
import { ProductsServices } from '../products/services';
import { DishServices } from '../dish/services';

//interface Restaurant
interface Restaurant {
  UID: string;
  UID_RESTAURANT: string;
  company: string;
  name: string;
  fiscal_name: string;
  cif: string;
  address: string;
  city: string;
  zip: string;
  country: string;
  province: string;
  phone: number;
  email: string;
  web: string;
  currency: string;
  tax_name: string;
  tax_percentage: number;
  timezone: string;
  tickets: any;
}

//interface User
interface User {
  UID: string;
  UID_RESTAURANT: string;
  date: string;
  email: string;
  rol: string;
}

//interface Ticket
interface Ticket {
  UID: string;
  UID_RESTAURANT: string;
  amount: number;
  cash_static: string;
  closed: boolean;
  date: any;
  list: any;
  number: number;
  payment: boolean;
  payment_type: string;
  table_uid: string;
  type: string;
  waiter: string;
  waiter_uid: string;
  tax: number;
}

//interface Cash
interface Cash {
  UID: string;
  UID_RESTAURANT: string;
  name: string;
  number: number;
}

//interface Variation
interface Variation {
  UID: string;
  UID_RESTAURANT: string;
  measurement: string;
  name: string;
  price: number;
  quantity: number;
  type: string;
  uid_element: string;
}

//interface Historial
interface Historial {
  UID: string;
  UID_RESTAURANT: string;
  name: string;
  date: string;
  tickets: any;
  total: number;
  total_cash: number;
  total_card: number;
  total_not_specified: number;
  total_notax: number;
  total_tax: number;
  tax: number;
  cash: string;
  uid_cash: string;

}
interface Table {
  UID: string;
  name: string;
  ticket: any;
  cash_static: any;
  cash_uid: any;
  type: string;
  discount_type: string;
  discount_value: number;
  room: any;
  persons: number;
}

interface Charge {
  UID: string;
}

@Injectable()

export class ConfigurationServices {
  // #region Variables
  restaurantCol: AngularFirestoreCollection<Restaurant>;
  restaurants: Observable<Restaurant[]>;
  restaurantDoc: AngularFirestoreDocument<Restaurant>;

  userCol: AngularFirestoreCollection<User>;
  userDoc: AngularFirestoreDocument<User>;
  users: Observable<User[]>;
  waiters: Observable<User[]>;

  ticketCol: AngularFirestoreCollection<Ticket>;
  ticketDoc: AngularFirestoreDocument<Ticket>;
  open_tickets: Observable<Ticket[]>;
  closed_tickets: Observable<Ticket[]>;
  pending_tickets: Observable<Ticket[]>;
  paid_tickets: Observable<Ticket[]>;

  tablesCol: AngularFirestoreCollection<Table>;
  tables: Observable<Table[]>;

  cashCol: AngularFirestoreCollection<Cash>;
  cashDoc: AngularFirestoreDocument<Cash>;
  cashs: Observable<Cash[]>;

  variationCol: AngularFirestoreCollection<Variation>;
  variationDoc: AngularFirestoreDocument<Variation>;
  variations: Observable<Variation[]>;

  historialCol: AngularFirestoreCollection<Historial>;
  historialDoc: AngularFirestoreDocument<Historial>;
  historials: Observable<Historial[]>;

  tickets_historial: Observable<Ticket[]>;

  chargeCol: AngularFirestoreCollection<Charge>;
  charges: Observable<Charge[]>;

  restaurant: any = Array();
  ticket_hedfoot: any = Array();
  cashs_array: any = Array();
  tickets_historials: any = Array();
  tickets_historial_array: any = Array();
  public valueChanges: any;
  public valueChangesCashs: any;
  public inserted: any = false;
  public hist: any;
  public firestore: any;
  public quick_create: boolean = false;

  //
  public historial: any;
  public ticket_amount: any;
  public historial_date: any;
  public arqueo: number = 0;
  public cash_name: string = '';


  limit_pages: number = 1;
  page_active: number = 1;

  pagesHistorial: any;
  historials_array: any;

  pagesTickets: any;
  tickets_array: any;

  pagesVariations: any;
  variations_array: any;
  fav_variations_array_tmp: any = Array();
  //complements
  complements_group_array: any = Array();
  complements_group_array_filtered: any = Array();
  complements_array: any = Array();
  complements_select: any = Array();
  complements_selected: any = Array();
  complements_groups_selected: any = Array();

  zip_codes: any;
  zip_code_show: any;

  /*biclosecash vars*/
  biclosecash_total: number = 0;
  biclosecash_total_notax: number = 0;
  biclosecash_total_tax: number = 0;
  biclosecash_total_taxes = [];
  biclosecash_sales_type_name = [];
  biclosecash_sales_type_amount = [];
  biclosecash_total_cash: number = 0;
  biclosecash_total_card: number = 0;
  biclosecash_total_stripe: number = 0;
  biclosecash_total_paypal: number = 0;
  biclosecash_total_payplaza: number = 0;
  biclosecash_total_verifone: number = 0;
  biclosecash_total_crypto: number = 0;
  biclosecash_total_not_specified: number = 0;
  biclosecash_total_btc: number = 0;
  biclosecash_total_bch: number = 0;
  biclosecash_total_dai: number = 0;
  biclosecash_total_doge: number = 0;
  biclosecash_total_eth: number = 0;
  biclosecash_total_ltc: number = 0;
  biclosecash_total_usdc: number = 0;
  biclosecash_total_redsys: number = 0;
  biclosecash_total_getnet: number = 0;
  biclosecash_total_comerciaglobalpay: number = 0;
  biclosecash_total_bank_transfer: number = 0;
  biclosecash_total_american_express: number = 0;
  biclosecash_total_bizum: number = 0;
  biclosecash_total_online: number = 0;
  biclosecash_total_bank_draft: number = 0;
  biclosecash_total_cryptocurrencies: number = 0;
  biclosecash_total_ticket_restaurant: number = 0;
  biclosecash_waiters = [];
  biclosecash_tickets = [];
  biclosecash_tickets_array_tmp = [];
  biclosecash_tickets_filtered = [];
  biclosecash_list_tickets_array = [];
  biclosecash_total_tips: number = 0;
  biclosecash_total_discount: number = 0;
  biclosecash_total_invite: number = 0;
  biclosecash_total_restaurant_ticket: number = 0;
  biclosecash_total_line_discount: number = 0;
  biclosecash_total_discounted: number = 0;
  biclosecash_total_with_tips: number = 0;
  biclosecash_deliveries = [];
  biclosecash_history = [];
  biclosecash_history_close_cash = [];
  biclosecash_arqueo: number = 0;
  biclosecash_total_incoming_cash: number = 0;
  biclosecash_total_outgoing_cash: number = 0;
  biclosecash_cash_name: string = '';
  biclosecash_historial_name: string = '';
  biclosecash_historial_created: any;
  biclosecash_tickets_canceled = [];
  biclosecash_avg_ticket: number = 0;
  biclosecash_persons_served: number = 0;
  biclosecash_avg_person_served: number = 0;
  biclosecash_customers_attended: number = 0;
  biclosecash_ticket_sale_max: number = 0;
  biclosecash_ticket_sale_min: number = 0;
  biclosecash_tickets_without_person: number = 0;
  biclosecash_foodcost: number = 0;
  biclosecash_benefit: number = 0;
  biclosecash_foodcost_percentage: number = 0;
  biclosecash_tip_cash: number = 0;
  biclosecash_tip_card: number = 0;
  biclosecash_tip_stripe: number = 0;
  biclosecash_tip_paypal: number = 0;
  biclosecash_tip_payplaza: number = 0;
  biclosecash_tip_verifone: number = 0;
  biclosecash_tip_not_specified: number = 0;
  biclosecash_tip_redsys: number = 0;
  biclosecash_tip_getnet: number = 0;
  biclosecash_tip_comerciaglobalpay: number = 0;
  biclosecash_tip_bank_transfer: number = 0;
  biclosecash_tip_american_express: number = 0;
  biclosecash_tip_bizum: number = 0;
  biclosecash_tip_online: number = 0;
  biclosecash_tip_bank_draft: number = 0;
  biclosecash_tip_cryptocurrencies: number = 0;
  biclosecash_tip_ticket_restaurant: number = 0;
  biclosecash_total_ratings: number;
  biclosecash_total_ratings_positive: number;
  biclosecash_total_ratings_negative: number;
  biclosecash_total_tpv: number = 0;
  biclosecash_total_online_methods: number = 0;
  biclosecash_total_others: number = 0;

  loadingComplementsGroups: boolean = false;
  loadingComplements: boolean = false;

  constructor(public afs: AngularFirestore,
    public datePipe: DatePipe,
    public globals: Globals,
    public ordersCoServices: OrdersCoServices,
    public incomeExpensesServices: IncomeExpensesServices,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public productsServices: ProductsServices,
    public dishServices: DishServices) {
    this.firestore = firebase.firestore();
  }

  //get restaurant
  getRestaurant(UID_RESTAURANT) {
    this.restaurantDoc = this.afs.doc('restaurants/' + UID_RESTAURANT);
    this.valueChanges = this.restaurantDoc.valueChanges().subscribe(value => {
      value.UID = UID_RESTAURANT; //Anadimos el UID al plato
      this.restaurant = value;
      this.ticket_hedfoot = value.tickets;
    });
  }

  async getRest(uid) {
    const restRef = this.firestore.collection('restaurants').doc(uid);

    var restaurant;

    await restRef.get().then(doc => {
      restaurant = doc.data();
      restaurant.UID = doc.id;
    })

    return restaurant

  }

  //get users
  async getUers(UID_RESTAURANT) {
    const usersRef = this.firestore.collection('users');

    var users = [];

    await usersRef.get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var user = doc.data();
          user.UID = doc.id;

          for (let key in user.restaurants) {
            if (user.restaurants[key].UID_RESTAURANT == UID_RESTAURANT) {
              user.key = key;
              users.push(user);
            }
          }

        });
      });

    return users
  }

  async getRoom(uid) {
    const cashRef = this.firestore.collection('rooms').doc(uid);

    var _cash;

    await
      cashRef.get().then(doc => {
        _cash = doc.data();
        _cash.UID = doc.id;
      });

    return _cash
  }
  // #region Tickets
  //get tickets open
  getOpenTickets(UID_RESTAURANT) {
    this.ticketCol = this.afs.collection('tickets', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('closed', '==', false)
      .where('pending', '==', false)
      .orderBy('date', 'desc')
    );
    this.open_tickets = this.ticketCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Ticket;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  //get tables and takeaway
  getTablesTakeaway(UID_RESTAURANT) {
    this.tablesCol = this.afs.collection('tables', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .orderBy('type', 'asc').orderBy('name', 'asc'));
    //.orderBy('type', 'asc').orderBy('order', 'asc'));

    this.tables = this.tablesCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Table;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  //get tickets closed
  getClosedTickets(UID_RESTAURANT) {
    this.ticketCol = this.afs.collection('tickets', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('closed', '==', true)
      .orderBy('date', 'desc'));
    this.closed_tickets = this.ticketCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Ticket;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  getPendingTickets(UID_RESTAURANT) {
    this.ticketCol = this.afs.collection('tickets', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('closed', '==', false)
      .where('pending', '==', true)
      .orderBy('date', 'desc'));
    this.pending_tickets = this.ticketCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Ticket;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  //get tickets paid
  getPaidTickets(UID_RESTAURANT) {
    this.ticketCol = this.afs.collection('tickets', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('payment', '==', true)
      .where('closed', '==', false)
      .orderBy('date', 'desc'));
    this.paid_tickets = this.ticketCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Ticket;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  //get ticket
  async getTicket(ticket_uid) {
    const ticketRef = this.firestore.collection('tickets').doc(ticket_uid);

    var ticket;

    await
      ticketRef.get().then(doc => {
        ticket = doc.data();
        ticket.UID = doc.id;
      });

    return ticket;
  }

  // #region Cash
  //get cashs
  getcashs(UID_RESTAURANT) {
    this.cashCol = this.afs.collection('cashs', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('number', 'desc'));
    this.cashs = this.cashCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Cash;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  async getAllCashs(UID_RESTAURANT) {
    const cashsRef = this.firestore.collection('cashs');

    var cashs = [];
    await cashsRef
      .where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('number', 'desc')
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var cash = doc.data();
          cash.UID = doc.id;

          cashs.push(cash);
        });
      });


    //For para poner en activo las cajas que puede ver el free.
    cashs.forEach((value, index) => {
      value._active = true;
      if (index >= 1 && !this.globals.checkLimitsByLicense('config', 'multi_cash')) {
        value._active = false;
      }
    });

    return cashs;
  }

  async getCash(cash_uid) {
    const cashRef = this.firestore.collection('cashs').doc(cash_uid);

    var _cash;

    await
      cashRef.get().then(doc => {
        _cash = doc.data();
        _cash.UID = doc.id;
      });

    return _cash
  }

  async getCashFirst(UID_RESTAURANT) {
    const variationsRef = this.firestore.collection('cashs');

    var cashs = [];

    await variationsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var cash = doc.data();
          cash.UID = doc.id;

          cashs.push(cash);
        });
      });

    //For para poner en activo las cajas que puede ver el free.
    cashs.forEach((value, index) => {
      value._active = true;
      if (index >= 1 && !this.globals.checkLimitsByLicense('config', 'multi_cash')) {
        value._active = false;
      }
    });

    return cashs;
  }
  // #region Complements & its groups
  //get variations
  getVariations(UID_RESTAURANT) {
    this.variationCol = this.afs.collection('variations', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT));
    this.variations = this.variationCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Variation;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  async getVariation(UID) {
    const varRef = this.firestore.collection('variations').doc(UID);

    var _variation;

    await varRef.get().then(doc => {
      _variation = doc.data();
      _variation.UID = doc.id;
    });

    return _variation
  }


  async getAllVariations(UID_RESTAURANT) {
    const variationsRef = this.firestore.collection('variations');

    var variations = [];

    await variationsRef
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var variation = doc.data();
          variation.UID = doc.id;

          variations.push(variation);
        });
      });

    return variations
  }

  async getComplementsGroups() {
    this.loadingComplementsGroups = true;
    this.complements_group_array = [];
    this.complements_group_searchbar_text = '';

    try {
      const snapshot = await this.firestore.collection('complements_groups')
        .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
        .get();

      if (snapshot.size > 0) {
        // Map new data
        let newGroups = snapshot.docs.map(doc => ({
          ...doc.data(),
          UID: doc.id
        }));

        // Remove duplicates based on UID
        this.complements_group_array = newGroups.filter((item, index, self) =>
          index === self.findIndex(t => t.UID === item.UID)
        );

        // Ensure filtered array updates too
        this.complements_group_array_filtered = [...this.complements_group_array];

      } else {
        this.complements_group_array = [];
        this.complements_group_array_filtered = [];
      }
    } catch (error) {

    } finally {
      this.loadingComplementsGroups = false;
    }
  }

  get_variation_done: boolean = false;
  variations_array_tmp: any = [];
  complements_array_tmp: any = [];
  variations_array_filtered: any = [];
  complements_array_filtered: any = [];
  list_variations_array: any = [];
  list_complements_array: any = [];
  variations_searchbar_text: string = '';
  complements_searchbar_text: string = '';
  complements_group_searchbar_text: string = '';
  async getPagesVariations() {
    this.get_variation_done = false;
    this.complements_searchbar_text = '';
    this.loadingComplements = true;

    try {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
      await this.http.post(this.globals.analytics_path + 'paginate/paginate_variations', params, {})
        .subscribe(async res => {
          this.variations_array_tmp = res['list'];
          this.complements_array_tmp = res['list'];
          if (this.complements_array_tmp.length != 0) {
            this.getListComplements();
          } else {
            this.resetVariations();
          }
        });
    } catch (error) {

    } finally {
      this.loadingComplements = false;
    }
  }

  private resetVariations() {
    this.list_variations_array = [];
    this.list_complements_array = [];
    this.complements_array_filtered = [];
    this.get_variation_done = true;
  }

  getListVariations() {
    this.get_variation_done = true;
    this.list_variations_array = [...this.list_dishes_products_ingredients_filtered]; // ✅ Ensure a new array reference
    this.variations_array_filtered = [...this.list_dishes_products_ingredients_filtered]; // ✅ Ensure deep copy
    this.variationsSearch(this.variations_searchbar_text);
  }

  variationsSearch(value: string) {
    if (value && value.trim().length > 0) {
      if (value.toLowerCase() === 'sin categoria' || value.toLowerCase() === 'sin categoría') {
        // Búsqueda específica para elementos sin categorías
        this.variations_array_filtered = this.list_dishes_products_ingredients.filter(obj => {
          return !obj.tags || obj.tags.length === 0;
        });
      } else {
        this.variations_array_filtered = this.list_dishes_products_ingredients.filter(obj => {
          // Buscar en el nombre del elemento usando la función de idioma apropiada
          let nameMatch = false;
          if (obj.type === 'dish') {
            const dishName = this.globals.nameLangSelectDish(obj);
            nameMatch = dishName.toLowerCase().includes(value.toLowerCase());
          } else if (obj.type === 'product') {
            const productName = this.globals.nameLangSelectProduct(obj);
            nameMatch = productName.toLowerCase().includes(value.toLowerCase());
          } else if (obj.type === 'ingredient') {
            const ingredientName = this.globals.nameLangSelectIngredient(obj);
            nameMatch = ingredientName.toLowerCase().includes(value.toLowerCase());
          }
          
          // Buscar en las categorías (tags)
          let categoryMatch = false;
          if (obj.tags && obj.tags.length > 0) {
            categoryMatch = obj.tags.some(tag => 
              tag.toLowerCase().includes(value.toLowerCase())
            );
          }
          
          // Buscar en otros campos relevantes usando objectToArray
          let otherFieldsMatch = false;
          const objectValues = this.globals.objectToArray(obj);
          otherFieldsMatch = objectValues.some(valor => {
            if (typeof valor === 'string' || typeof valor === 'number') {
              return valor.toString().toLowerCase().includes(value.toLowerCase());
            } else if (Array.isArray(valor)) {
              return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
            }
            return false;
          });
          
          // Mostrar si coincide con nombre, categoría u otros campos
          return nameMatch || categoryMatch || otherFieldsMatch;
        });
      }
    } else {
      this.variations_array_filtered = [...this.list_dishes_products_ingredients];
    }

    this.list_dishes_products_ingredients_filtered = [...this.variations_array_filtered];
    this.filterDishesProductsIngredients(true);
  }


  filterDishesProductsIngredients(from_search = false) {
    var _array = this.list_dishes_products_ingredients;
    if (from_search) {
      _array = this.list_dishes_products_ingredients_filtered;
    }
    this.list_dishes_products_ingredients_filtered = _array.filter(element => {
      if (this.showArticles && (element.type === "product" || element.type === "dish")) {
        return true;
      }
      if (this.showIngredients && element.type === "ingredient") {
        return true;
      }

      return false;
    });

    if (!from_search) {
      this.variationsSearch(this.variations_searchbar_text);
    }
  }

  list_dishes_products_ingredients: any = [];
  list_dishes_products_ingredients_filtered: any = [];
  loader_dishes_products_ingredients: boolean;
  showIngredients: boolean = true;
  showArticles: boolean = true;
  async getDishesProductsIngredients() {
    this.loader_dishes_products_ingredients = true;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    var res = await this.http.post(this.globals.analytics_path + 'get/dishes_products_ingredients', params, {}).toPromise();

    if (res && res['list']) {
      this.list_dishes_products_ingredients = res['list'];
      this.list_dishes_products_ingredients.sort((a, b) =>
        this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b))
      );
      this.list_dishes_products_ingredients_filtered = [...this.list_dishes_products_ingredients]; // ✅ Ensure deep copy
    } else {
      this.list_dishes_products_ingredients = [];
      this.list_dishes_products_ingredients_filtered = [];
    }

    this.loader_dishes_products_ingredients = false;
    this.variationsSearch(this.variations_searchbar_text);

    return true;
  }

  // Articles (simple and with recipe breakdown) and ingredients filter
  filterComplements(from_search = false) {
    var _array = this.list_complements_array;
    if (from_search) {
      _array = [...this.complements_array_filtered];
    }
    this.complements_array_filtered = _array.filter(element => {
      if (this.showArticles && (element.type === "product" || element.type === "dish")) {
        return true;
      }
      if (this.showIngredients && element.type === "ingredient") {
        return true;
      }
      if (!element.type || element.type === "") {
        return true;
      }
      return false;
    });

    if (!from_search) {
      this.complementsSearch(this.complements_searchbar_text);
    }
  }

  getListComplements() {
    this.get_variation_done = true;
    this.complements_array_tmp.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
    this.list_complements_array = this.complements_array_tmp;
    this.complements_array_filtered = this.complements_array_tmp;
    this.complementsSearch(this.complements_searchbar_text);
  }

  complementsSearch(value: any) {
    if (value && value.trim() !== '') {
      this.complements_array_filtered = this.list_complements_array.filter(obj => {
        return this.globals.objectToArray(obj).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
      this.complements_array_filtered = this.complements_array_filtered;
    } else {
      this.complements_array_filtered = [...this.list_complements_array];
    }
    this.filterComplements(true);
  }

  groupComplementsSearch(value: any) {
    if (value && value.trim() !== '') {
      this.complements_group_array_filtered = this.complements_group_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
      this.complements_group_array_filtered = this.complements_group_array_filtered;
    } else {
      this.complements_group_array_filtered = [...this.complements_group_array];
    }
  }

  // #region Historial
  //get historial
  getHistorial(UID_RESTAURANT) {
    this.historialCol = this.afs.collection('historial', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .orderBy('date', 'desc'));
    this.historials = this.historialCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Historial;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  async getTicketsHistorial(UID_RESTAURANT, p_name, p_uid, form) {

    //init vars totales
    var total = 0;
    var total_notax = 0;
    var total_tax = 0;
    var tickets = [];
    var total_cash = 0;
    var total_card = 0;
    var total_not_specified = 0;
    var tax = 0;
    //init vars descuentos
    var total_discount = 0;
    var total_invite = 0;
    var total_restaurant_ticket = 0;
    var total_line_discount = 0;
    //init vars tips
    var total_tips = 0;
    //init vars delivery
    var sales_type_name = ['delivery', 'table', 'bar'];
    var sales_type_amount = [0, 0, 0];
    var deliveries = [];
    //init vars waiters
    var waiters = [];

    //recuperar caja
    var cash = await this.getCash(p_uid);

    //recuperamos los tickets pendientes de cierre de la caja
    var ticketsRef = this.afs.collection('tickets').ref;
    ticketsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('cash_uid', '==', p_uid)
      .where('pending', '==', false)
      .where('closed', '==', false)
      .get()
      .then(async snapshot => {
        snapshot.forEach(doc => {
          //tratamos los datos
          var ticket = doc.data();
          ticket.UID = doc.id;
          //calcular total
          if (ticket.closed == false && ticket.payment == true) {
            tax = ticket.tax;
            //insert uid tiquets at list
            tickets.push(ticket.UID);

            //calculate total,tax etc
            total = Number(total) + Number(ticket.amount);
            var tmp_total_notax = this.globals.createSubTotal(Number(ticket.amount), Number(ticket.tax));
            total_notax = total_notax + tmp_total_notax;
            total_tax = Number(total_tax) + (Number(ticket.amount) - tmp_total_notax);
            if (ticket.payment_type == 'card') {
              total_card = Number(total_card) + Number(ticket.amount);
            } else if (ticket.payment_type == 'cash') {
              total_cash = Number(total_cash) + Number(ticket.amount);
            } else {
              total_not_specified = Number(total_not_specified) + Number(ticket.amount);
            }

            //calculate discount
            if (ticket.discount_type == 'discount') {
              if (ticket.discount_value) {
                total_discount += ticket.discount_value;
              }
            } else if (ticket.discount_type == 'invite') {
              if (ticket.discount_value) {
                total_invite += ticket.discount_value;
              }
            } else if (ticket.discount_type == 'linediscount') {
              if (ticket.discount_value) {
                total_line_discount += ticket.discount_value
              }
            } else {
              if (ticket.discount_value) {
                total_restaurant_ticket += ticket.discount_value;
              }
            }

            //tips
            if (ticket.tip) {
              total_tips += ticket.tip;
            }

            //deliveries
            if (ticket.type == 'takeaway') {

              //INFO DONUT
              //mirar si ya existe el delivery en el array
              var index_name = sales_type_name.findIndex(name => name == 'delivery');
              if (index_name < 0) {//si no existe crear
                sales_type_name.push('delivery');
                var index_exist = sales_type_name.findIndex(name => name == 'delivery');
                sales_type_amount[index_exist] = ticket.amount;
              } else {//si existe sumar amount en su posicion del array
                sales_type_amount[index_name] += ticket.amount;
              }

              //INFO TABLE
              //mirar si ya existe el delivery en el array
              var index_delivery = deliveries.findIndex(element => element.name == ticket.delivery);
              if (index_delivery < 0) {//si no existe crear
                deliveries.push({
                  name: ticket.delivery,
                  tickets: 1,
                  total: ticket.amount
                });
              } else {//si existe sumar amount en su posicion del array
                deliveries[index_delivery].tickets += 1;
                deliveries[index_delivery].total += ticket.amount;
              }

            } else {
              //INFO DONUT
              //mirar si ya existe el type en el array
              var index_type = sales_type_name.findIndex(name => name == ticket.type);
              if (index_type < 0) {//si no existe crear
                sales_type_name.push(ticket.type);
                var index_exist_delivery = sales_type_name.findIndex(name => name == ticket.type);
                sales_type_amount[index_exist_delivery] = ticket.amount;
              } else {//si existe sumar 1 en su posicion del array
                sales_type_amount[index_type] += ticket.amount;
              }
            }

            //waiters
            var index_waiters = waiters.findIndex(item => item.waiter_uid == ticket.waiter_uid);
            if (index_waiters < 0) {//si no existe crear

              var _deletes = [];
              for (let element of this.globals.objectToArray(ticket.list)) {
                //cuando se cambian elementos por otros -> el anterior se pone como si se hubiera eliminado
                if (element.count == false || element.delete) {
                  _deletes.push(element);
                }
              }
              //
              waiters.push({
                waiter_uid: ticket.waiter_uid,
                name: ticket.waiter,
                total: ticket.amount,
                tickets: 1,
                deletes: _deletes,
              });
            } else {//si existe sumar 1 en tickets, amount y eliminados en su posicion del array
              waiters[index_waiters].total += ticket.amount;
              waiters[index_waiters].tickets += 1;
              //
              for (let element of this.globals.objectToArray(ticket.list)) {
                if (element.count == false || element.delete) {
                  waiters[index_waiters].deletes.push(element);
                }

              }
            }

          }

          //delete table tk AND clean orders
          if (ticket.type == 'takeaway') {
            this.ordersCoServices.deleteTableTKWhenCloseCash(ticket.table_uid);
            this.ordersCoServices.deleteOrdersWhenPay(this.globals.restaurant_uid, ticket.table_uid);
          }

        });

        //limpia orders en el limbo
        this.ordersCoServices.deleteOrdersTKWhenCancelTicket(this.globals.restaurant_uid);
        //limpia orders de cocina que estan ocultos
        this.ordersCoServices.deleteKitchenHiddenOrders(this.globals.restaurant_uid);
        //insertamos
        await this.insertHistorial(UID_RESTAURANT, form, p_name, p_uid, tickets, total, total_cash, total_card, total_not_specified, total_notax, total_tax, tax, cash, total_discount, total_invite, total_restaurant_ticket, total_line_discount, total_tips, sales_type_name, sales_type_amount, deliveries, waiters)
      })
      .catch(err => { });
  }

  totalNoTax(total, tax) {
    var sub = total / ((parseFloat(tax) + 100) / 100);
    return sub;
  }

  async insertHistorial(UID_RESTAURANT, form, p_name, p_uid, tickets, total, total_cash, total_card, total_not_specified, total_notax, total_tax, tax, cash, total_discount, total_invite, total_restaurant_ticket, total_line_discount, total_tips, sales_type_name, sales_type_amount, deliveries, waiters) {
    //cash
    if (total_cash != 0) {
      this.incomeExpensesServices.afs.collection('income').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'number': '',
        'date': new Date(),//mom
        'concept': this.datePipe.transform(form, "dd-MM-yyyy ") + ' - ' + p_name,
        'base': this.totalNoTax(total_cash, this.globals.RESTAURANT_TAX),
        'tax': this.globals.RESTAURANT_TAX,
        'total': total_cash,
        'payment_method': 'efectivo',

      }).then(doc => {
      });
    }

    //card
    if (total_card != 0) {
      this.incomeExpensesServices.afs.collection('income').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'number': '',
        'date': new Date(),//mom
        'concept': this.datePipe.transform(form, "dd-MM-yyyy ") + ' - ' + p_name,
        'base': this.totalNoTax(total_card, this.globals.RESTAURANT_TAX),
        'tax': this.globals.RESTAURANT_TAX,
        'total': total_card,
        'payment_method': 'tarjeta',

      }).then(doc => {
      });
    }
    //not_specified
    if (total_not_specified != 0) {
      this.incomeExpensesServices.afs.collection('income').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'number': '',
        'date': new Date(),//mom
        'concept': this.datePipe.transform(form, "dd-MM-yyyy ") + ' - ' + p_name,
        'base': this.totalNoTax(total_not_specified, this.globals.RESTAURANT_TAX),
        'tax': this.globals.RESTAURANT_TAX,
        'total': total_not_specified,
        'payment_method': 'otro',

      }).then(doc => {
      });
    }


    if (cash.history == undefined) {
      cash.history = Array();
    }

    //insertar historial
    this.afs.collection('historial').add({
      UID_RESTAURANT: UID_RESTAURANT,
      name: this.datePipe.transform(form, "dd-MM-yyyy ") + ' - ' + p_name,
      date: new Date(form),
      tickets: tickets,
      total: total,
      total_cash: total_cash,
      total_card: total_card,
      total_not_specified: total_not_specified,
      total_notax: total_notax,
      total_tax: total_tax,
      tax: tax,
      cash: p_name,
      uid_cash: p_uid,
      history: cash.history,
      user_closed: this.globals.user_name + "-" + this.globals.user_email,
      total_discount: total_discount,
      total_invite: total_invite,
      total_restaurant_ticket: total_restaurant_ticket,
      total_line_discount: total_line_discount,
      total_tips: total_tips,
      sales_type_name: sales_type_name,
      sales_type_amount: sales_type_amount,
      deliveries: deliveries,
      waiters: waiters,

    }).then(hist => {
      var historialRef = this.afs.collection('historial').doc(hist.id).ref;
      historialRef.get()
        .then(async doc => {
          //datastore cierre caja
          var extra = {
            "cash": total_cash,
            "card": total_card,
            "not_specified": total_not_specified,
          };
          this.globals.dataSet('sales_day', total, '', JSON.stringify(extra), '');//Send dish data
          //limpiar
          var docHistorial = doc.data();
          docHistorial.UID = doc.id;
          this.hist = docHistorial;
          this.updateTicketToClosed(tickets);
          this.cleanCashHistory(cash);
        })
        .catch(err => { });


    });

    this.inserted = true;
  }

  updateTicketToClosed(tickets) {
    for (let ticket of tickets) {
      this.afs.collection('tickets').doc(ticket).update({
        'closed': true,
      });
    }
    this.inserted = true;
  }

  cleanCashHistory(cash) {
    this.afs.collection('cashs').doc(cash.UID).update({
      'history': [],
    });
  }

  ticketsHistorialArrayActive: boolean = false;
  async getTicketsFromCash(tickets) {
    this.tickets_historial_array = [];
    this.ticketsHistorialArrayActive = false;

    const params = new HttpParams()
      .set('tickets', JSON.stringify(tickets));
    await this.http.post(this.globals.analytics_path + 'tickets/return_tickets_from_list', params, {})
      .subscribe(async res => {
        this.tickets_historial_array = res;
        this.ticketsHistorialArrayActive = true;
      });
  }

  returnBigMeasurement(measurement) {
    if (measurement == 'gr') {
      return 'kg';
    } else if (measurement == 'ml') {
      return 'l';
    } else {
      return measurement;
    }
  }

  returnCalculatedBigMeasurement(quanitity, measurement) {
    if (measurement == 'gr') {
      return quanitity / 1000;
    } else if (measurement == 'ml') {
      return quanitity / 1000;
    } else {
      return quanitity;
    }
  }

  async getUser(email) {
    const col = this.firestore.collection('users');
    const query = col.where('email', '==', email);

    var _user;

    await query.get().then(snapshot => {
      snapshot.docs.forEach(doc => {
        _user = doc.data();
        _user.UID = doc.id;
      })
    });

    return _user
  }

  async getUserByUID(uid) {
    const query = this.firestore.collection('users').doc(uid);

    var _user;

    await query.get().then(snapshot => {
      snapshot.docs.forEach(doc => {
        _user = doc.data();
        _user.UID = doc.id;
      })
    });

    return _user
  }

  // #region PANTALLA BLOQUEO

  users_screen_block: any;
  getUsersScreenBlock(UID_RESTAURANT) {
    this.ticketCol = this.afs.collection('screen_block', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT));
    this.users_screen_block = this.ticketCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Ticket;
        data.UID = a.payload.doc.id;
        return data;
      });
    });


  }

  async getUsersScreenBlockAsync(UID_RESTAURANT) {
    const col = this.firestore.collection('screen_block');
    const query = col.where('UID_RESTAURANT', '==', UID_RESTAURANT);

    var users = [];

    await query.get().then(snapshot => {
      snapshot.docs.forEach(doc => {
        var user = doc.data();
        user.UID = doc.id;
        users.push(user);
      })
    });

    return users
  }


  filteredHistorialActive: boolean = false;
  filteredHistorial: any;
  searchHistorialNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredHistorialActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'filter/close_cash', params, {})
          .subscribe(async res => {
            this.filteredHistorial = res;
            this.filteredHistorialActive = true;
          });
      } else {
        this.filteredHistorialActive = false;
      }
    }
  }

  get_historial_done: boolean = false;
  first_close_cash_name: any;
  list_close_cash: any;
  async getPagesHistorial(elements_per_page) {
    this.get_historial_done = false;
    this.filteredHistorialActive = false;
    this.limit_pages = elements_per_page;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'paginate/close_cash', params, {})
      .subscribe(async res => {
        this.pagesHistorial = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.list_close_cash = res['list_close_cash'];
        if (this.pagesHistorial != 0) {
          this.getListHistorial();
        } else {
          this.filteredHistorialActive = true;
        }
      });
  }
  getListHistorial() {
    this.get_historial_done = true;
    //Search for first element to start
    this.first_close_cash_name = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    this.historials_array = this.list_close_cash.slice(this.first_close_cash_name, this.first_close_cash_name + this.limit_pages);
  }

  filteredTicketActive: boolean = false;
  filteredTicket: any;
  searchTicketsNode(value, type, date_first, date_last) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredTicketActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('type', type)
          .set('filter_string', value.target.value.toLowerCase())
          .set('datetime_init', date_first)
          .set('datetime_final', date_last);

        this.http.post(this.globals.analytics_path + 'filter/tickets', params, {})
          .subscribe(async res => {
            this.filteredTicket = res;
            this.filteredTicketActive = true;
          });
      } else {
        this.filteredTicketActive = false;
      }
    }
  }

  //get_tickets_done: boolean = false;
  list_tickets: any;
  first_ticket_name: any;
  async getPagesTickets(elements_per_page, type, date_first, date_last) {
    this.get_tickets_done = false;
    this.filteredTicketActive = false;
    this.limit_pages = elements_per_page;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('type', type)
      .set('elements_per_page', elements_per_page)
      .set('datetime_init', date_first)
      .set('datetime_final', date_last);
    await this.http.post(this.globals.analytics_path + 'paginate/tickets', params, {})
      .subscribe(async res => {
        this.pagesTickets = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.list_tickets = res['list_tickets'];
        if (this.pagesTickets != 0) {
          this.getListTickets();
        } else {
          this.filteredTicketActive = true;
          this.get_tickets_done = true;
        }
      });
  }
  getListTickets() {
    this.get_tickets_done = true;
    //Search for first element to start
    this.first_ticket_name = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    this.tickets_array = this.list_tickets.slice(this.first_ticket_name, this.first_ticket_name + this.limit_pages);
  }


  filteredVariationsActive: boolean = false;
  filteredVariations: any;
  searchVariationsNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredVariationsActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());

        this.http.post(this.globals.analytics_path + 'filter/filter_variations', params, {})
          .subscribe(async res => {
            this.filteredVariations = res;
            this.filteredVariationsActive = true;
          });
      } else {
        this.filteredVariationsActive = false;
      }
    }
  }

  // #region COBROS Y PAGOS
  getListCharges(UID_RESTAURANT) {
    this.chargeCol = this.afs.collection('restaurants/' + UID_RESTAURANT + '/charges', ref => ref
      .where('paid', '==', true)
      .orderBy('date', 'desc'));
    this.charges = this.chargeCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Charge;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  // #region WEB
  async getCP() {
    const zipcodeRef = this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/zip_codes');

    this.zip_codes = [];
    this.zip_code_show = '';

    await zipcodeRef.orderBy('name').get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          const zip_code = doc.data();
          zip_code.UID = doc.id;

          this.zip_codes.push(zip_code);
        });
      });
    await this.zip_codes.forEach(element => {
      this.zip_code_show += element.code + ',';
    });
  }

  last5_tickets: any = [];

  getLast5Tickets(UID_RESTAURANT) {
    //
    const params = new HttpParams()
      .set('uid_restaurant', UID_RESTAURANT);
    this.http.post(this.globals.analytics_path + 'tickets/get_last_delivery_types', params, {})
      .subscribe(res => {
        this.last5_tickets = res['last5_tickets'];
      });
  }

  //Dishes/Products
  dishes_products_array_tmp: any = [];

  filteresDishesProducts: any;
  filteresDishesProductsActive: any;
  get_dishes_products_done: boolean = false;
  searchDishesProductsNode(value) {
    this.get_dishes_products_done = false;
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteresDishesProductsActive = false;
      this.get_dishes_products_done = true;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());

        this.http.post(this.globals.analytics_path + 'filter/dishes_products', params, {})
          .subscribe(async res => {
            this.filteresDishesProducts = res;
            this.filteresDishesProductsActive = true;
            this.get_dishes_products_done = true;
          });
      } else {
        this.filteresDishesProductsActive = false;
        this.get_dishes_products_done = true;
      }
    }
  }

  list_dishes_products_array: any;
  first_dishes_products_name: any;
  pages_dishes_products: any;
  dishes_products_array: any;
  async getPagesDishesProducts(elements_per_page) {
    this.get_dishes_products_done = false;
    this.filteresDishesProductsActive = false;
    this.limit_pages = elements_per_page;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'paginate/dishes_products', params, {})
      .subscribe(async res => {
        this.pages_dishes_products = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.list_dishes_products_array = res['list'];
        this.list_dishes_products_array.sort((a, b) => a.name.localeCompare(b.name));
        if (this.pagesVariations != 0) {
          this.getListDishesProducts();
        } else {
          this.filteresDishesProductsActive = true;
        }
      });
  }

  getListDishesProducts() {
    this.get_dishes_products_done = true;
    //Search for first element to start
    this.first_dishes_products_name = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    if (this.limit_pages > 0) {
      this.dishes_products_array = this.list_dishes_products_array.slice(this.first_dishes_products_name, this.first_dishes_products_name + this.limit_pages);
    } else {
      this.dishes_products_array = this.list_dishes_products_array;
    }
  }

  selects_deliveries = [];
  deliveries_favorites: any;


  async recoveryDeliveriesFavorites() {
    this.selects_deliveries = [];
    this.deliveries_favorites = this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries_favorites');

    await this.deliveries_favorites.get()
      .then(snapshot => {
        snapshot.forEach(async doc => {
          var _elements = doc.data();
          _elements.UID = doc.id;
          this.selects_deliveries.push(_elements);
        });
      });
  }

  async deleteToken(user_id, token_user) {
    if (user_id && token_user) {
      //recuperamos tokens para borar
      var tokens = await this.getTokens2Delete(user_id, token_user);
      //borramos tokens
      for (let token of tokens) {
        await token.ref.delete();
      }
    }

  }

  //funcion que recupera tokens para borrarlos
  async getTokens2Delete(user_id, token_user) {
    var tokens = [];
    await this.firestore.collection('users').doc(user_id).collection('push_tokens').where('token', '==', token_user).get()
      .then((snapshot) => {
        snapshot.forEach(async (doc) => {
          tokens.push(doc);
        });
      })

    return tokens;
  }

  //funcion que hace un update a col tables para desmarcar que esta visto que esta pagada esa mesa
  updatePopupTablePaid(uid_table) {

    this.afs.collection('tables').doc(uid_table).update({
      'payment': false,
      'payment_source': '',
    });

  }


  async getMenusCartasTKActive() {
    var all_menuscartas = [];

    await this.firestore.collection('menus').where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('tk_active', '==', true).get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          var menu = doc.data();
          menu.UID = doc.id;
          if (menu.type === "combo") {
            menu.tk_type = 'combo';
          } else {
            menu.tk_type = 'menu';
          }
          all_menuscartas.push(menu);
        });
      });

    await this.firestore.collection('cartas').where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('tk_active', '==', true).get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          var carta = doc.data();
          carta.UID = doc.id;
          carta.tk_type = 'carta';
          all_menuscartas.push(carta);
        });
      });

    return all_menuscartas;
  }

  async getAllTables() {
    var all_tables = [];
    await this.firestore.collection('tables')
      .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('type', '<', 'takeaway')
      .orderBy('type', 'asc')
      .orderBy('order', 'asc')
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          var table = doc.data();
          table.UID = doc.id;
          all_tables.push(table);
        });
      });

    return all_tables;
  }


  async getAllTypeTables() {
    var all_tables = [];
    await this.firestore.collection('tables')
      .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('type', '==', 'table')
      .orderBy('type', 'asc')
      .orderBy('order', 'asc')
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          var table = doc.data();
          table.UID = doc.id;
          all_tables.push(table);
        });
      });

    return all_tables;
  }

  async getAllRooms() {
    var all_rooms = [];
    await this.firestore.collection('rooms')
      .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          var room = doc.data();
          room.UID = doc.id;
          all_rooms.push(room);
        });
      });

    return all_rooms;
  }

  get_tickets_done: boolean = false;
  tickets_array_tmp: any = [];
  list_tickets_array: any = [];
  tickets_array_filtered: any = [];
  tickets_searchbar_text: any = '';

  async getNodeTickets(type, date_first, date_last) {
    this.get_tickets_done = false;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('type', type)
      .set('datetime_init', date_first)
      .set('datetime_final', date_last);
    await this.http.post(this.globals.analytics_path + 'paginate/tickets/v2', params, {})
      .subscribe(async res => {
        this.tickets_array_tmp = res['list'];
        this.getListTicketsMinMax();
      });
  }

  getListTicketsMinMax() {
    this.get_tickets_done = true;
    this.list_tickets_array = this.tickets_array_tmp;
    this.tickets_array_filtered = this.tickets_array_tmp;
    this.ticketsSearch(this.tickets_searchbar_text);
  }

  ticketsSearch(value) {
    if (value) {
      this.tickets_array_filtered = this.list_tickets_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.tickets_array_filtered = this.list_tickets_array;
    }
  }

  updateRestaurantColors(primary: string, secondary: string) {
    this.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      primary_color: primary,
      secondary_color: secondary
    }).catch(error => {});
  }

  async getComplement(uid: string) {
    try {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('complement_uid', uid);
      const res = await this.http.post(this.globals.analytics_path + 'get/complement', params, {}).toPromise();
      if (res && res['complement']) {
        return {
          ...res['complement'],
          name: res['complement'].name || '',
          name_en: res['complement'].name_en || '',
          name_fr: res['complement'].name_fr || '',
          name_de: res['complement'].name_de || '',
          name_it: res['complement'].name_it || '',
          name_ca: res['complement'].name_ca || ''
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  async updateComplement(complement: any) {
    /*try {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('complement_uid', complement.uid);
      
      const dataToUpdate = {
        ...complement,
        name: complement.name || '',
        name_en: complement.name_en || '',
        name_fr: complement.name_fr || '',
        name_de: complement.name_de || '',
        name_it: complement.name_it || '',
        name_ca: complement.name_ca || ''
      };

      const res = await this.http.post(this.globals.analytics_path + 'update/complement', dataToUpdate, {}).toPromise();
      return res;
    } catch (error) {
      console.error('Error updating complement:', error);
      return false;
    }*/
  }

  async createComplement(complement: any) {
    try {
      const dataToCreate = {
        uid: this.globals.restaurant_uid,
        name: complement.name || '',
        name_en: complement.name_en || '',
        name_fr: complement.name_fr || '',
        name_de: complement.name_de || '',
        name_it: complement.name_it || '',
        name_ca: complement.name_ca || '',
        quantity: complement.quantity,
        price: complement.price,
        measurement: complement.measurement,
        type: complement.type,
        uid_element: complement.uid_element
      };

      const res = await this.http.post(this.globals.analytics_path + 'create/complement', dataToCreate).toPromise();
      return res;
    } catch (error) {
      return false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/configuration/services.ts